import apiService from '@/services/apiService';

const actions = {
  getWasteTypes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/waste-type/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getWasteType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-recycle/waste-type/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderWasteType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-recycle/waste-type/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postWasteType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/waste-type', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putWasteType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-recycle/waste-type/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delWasteType({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxel-recycle/waste-type/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
